import React from 'react';
import type { ProfitLossReportData, MessageButton } from '../../../../types/chat-message';
import { ReportActionButtons } from './ReportActionButtons';
import './RevenueReport.scss';

const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('vi-VN', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount) + 'đ';
};

interface ProfitLossReportProps {
  data?: ProfitLossReportData;
  buttons?: MessageButton[];
  onButtonClick?: (name: string, id: number, isHidden?: boolean) => void;
  isLastMessage?: boolean;
  isFromHistory?: boolean;
  text?: string | null;
}

interface MetricRowProps {
  label: string;
  value: number;
  rate?: number;
  isHighlight?: boolean;
}

const MetricRow: React.FC<MetricRowProps> = ({
  label,
  value,
  rate,
  isHighlight
}) => {
  const isUp = rate !== undefined && rate > 0;
  const isDown = rate !== undefined && rate < 0;
  const hasIndicator = isUp || isDown;

  return (
    <div className="rr-metric-row">
      <div className="rr-metric-label-group">
        <span className="rr-metric-label">{label}</span>
        {hasIndicator && (
          <span className={`rr-metric-change ${isUp ? 'up' : 'down'}`}>
            {isUp ? '▲' : '▼'} {Math.abs(rate!).toFixed(2)}%
          </span>
        )}
      </div>
      <span className={`rr-metric-value ${isHighlight ? 'highlight' : ''}`}>
        {formatCurrency(value)}
      </span>
    </div>
  );
};

export const ProfitLossReport: React.FC<ProfitLossReportProps> = ({
  data,
  buttons,
  onButtonClick,
  isLastMessage,
  isFromHistory,
  text,
}) => {
  


  const {
    timeRange,
    totalRevenue = 0,
    totalCost = 0,
    totalProfit = 0,
    totalProfitRate,
    totalProfitOther = 0,
    totalRevenueRate,
    totalCostRate,
    totalProfitOtherRate,
  } = data ?? {};

  console.log(79, text)


  const isButtonDisabled = !isLastMessage || !!isFromHistory;

  return (
    <div className="revenue-report">
    {!data ? (
        <div className="">
          <span className="">{text}</span>
        </div>
      ) : (
      <>
      <div className="rr-header">
        <span className="rr-title">{text || `BÁO CÁO LÃI LỖ ${timeRange || ''}`}</span>
      </div>
      <div className="rr-metrics">
        <MetricRow label="Lợi nhuận" value={totalProfit} rate={totalProfitRate} />
        <MetricRow label="Doanh thu" value={totalRevenue} rate={totalRevenueRate} />
        <MetricRow label="Giá vốn" value={totalCost} rate={totalCostRate} />
        <MetricRow label="Lợi nhuận khác" value={totalProfitOther} rate={totalProfitOtherRate} />
      </div>
      </>
      )}
      
      <ReportActionButtons
        buttons={buttons}
        isDisabled={isButtonDisabled}
        onButtonClick={onButtonClick}
        reportType="Báo cáo lãi lỗ"
      />
    </div>
  );
};
